import moment from 'moment';
import * as Yup from 'yup';

const FORM_DATE_FORMAT = 'DD/MM/YYYY';
const API_DATE_FORMAT = 'YYYY-MM-DD';

export const RNTRC_TYPE_NAMES = ['ETC', 'TAC', 'CTC'];

export const RNTRC_MESSAGES = {
  ISSUE_DATE_FUTURE: 'A data de emissão da RNTRC não pode ser futura',
  EXP_BEFORE_ISSUE: 'A data de validade da RNTRC deve ser posterior à data de emissão',
  INVALID_DATE: 'Informe uma data válida',
};

// Máscara vazia ('__/__/____') ou só espaços conta como "não informado"
function isEmptyDate(value) {
  return !value || !String(value).replace(/[_/\s]/g, '');
}

function parseFormDate(value) {
  return moment(value, FORM_DATE_FORMAT, true);
}

export function toApiDate(value) {
  if (isEmptyDate(value)) return null;
  const date = parseFormDate(value);
  return date.isValid() ? date.format(API_DATE_FORMAT) : null;
}

export function fromApiDate(value) {
  if (!value) return '';
  const date = moment.utc(value);
  return date.isValid() ? date.format(FORM_DATE_FORMAT) : '';
}

export function rntrcIssueDateSchema({
  required = false,
  requiredMessage = 'Informe a data de emissão',
} = {}) {
  return Yup.string()
    .nullable()
    .test('required', requiredMessage, (value) => !required || !isEmptyDate(value))
    .test('valid-date', RNTRC_MESSAGES.INVALID_DATE, (value) =>
      isEmptyDate(value) ? true : parseFormDate(value).isValid(),
    )
    .test('not-future', RNTRC_MESSAGES.ISSUE_DATE_FUTURE, (value) => {
      if (isEmptyDate(value)) return true;
      const date = parseFormDate(value);
      return !date.isValid() || !date.isAfter(moment(), 'day');
    });
}

export function rntrcExpDateSchema(issueField) {
  return Yup.string()
    .nullable()
    .test('valid-date', RNTRC_MESSAGES.INVALID_DATE, (value) =>
      isEmptyDate(value) ? true : parseFormDate(value).isValid(),
    )
    .test('after-issue', RNTRC_MESSAGES.EXP_BEFORE_ISSUE, function validateAfterIssue(value) {
      const issueValue = this.parent?.[issueField];
      if (isEmptyDate(value) || isEmptyDate(issueValue)) return true;

      const expDate = parseFormDate(value);
      const issueDate = parseFormDate(issueValue);
      if (!expDate.isValid() || !issueDate.isValid()) return true;

      return expDate.isAfter(issueDate, 'day');
    });
}

export function filterRntrcTypes(anttTypes = []) {
  return (anttTypes || []).filter((item) => RNTRC_TYPE_NAMES.includes(item?.name));
}
